import { Box, Button, lighten, useTheme } from '@mui/material';
import Grid2 from '@mui/material/Unstable_Grid2';
import { useTranslation } from 'react-i18next';
import SvgIcon from '../components/SvgIcon';
import { IOnlinePreferredTourCategory } from '../utils/types';
import { LinkBehavior } from './LinkBehavior';

export function TourCategoryButtons(props: {
  data: IOnlinePreferredTourCategory[];
}) {
  const { t } = useTranslation();
  const theme = useTheme();

  return (
    <Grid2 container spacing={1} justifyContent="center" flexWrap="wrap">
      {props.data
        ?.sort((a, b) => a.order - b.order)
        .map((r: IOnlinePreferredTourCategory, index) => (
          <Grid2 key={index} xs={[7, 5, 5][index % 3]} lg={2}>
            <Button
              LinkComponent={LinkBehavior}
              href={`/tours?categories=${r.id}`}
              variant="text"
              sx={{
                bgcolor: lighten(theme.palette.primary.main, 0.9),
                ['&:hover']: {
                  bgcolor: lighten(theme.palette.primary.main, 0.8),
                },
                textWrap: 'nowrap',
              }}
              fullWidth
            >
              {r.iconPath && (
                <SvgIcon
                  style={{
                    width: 24,
                    height: 24,
                    marginTop: 0,
                    marginRight: 8,
                  }}
                  src={r.iconPath}
                />
              )}
              <Box
                component="span"
                sx={{ overflow: 'hidden', textOverflow: 'ellipsis' }}
              >
                {t(r.name)}
              </Box>
            </Button>
          </Grid2>
        ))}
      <Grid2
        sx={{ flexGrow: { xs: 1, lg: 'unset' } }}
        xs={[8, 4, 4][props.data.length % 3]}
        lg={2}
      >
        <Button
          href="https://flyhisar.com/"
          target="_blank"
          sx={{
            bgcolor: lighten(theme.palette.primary.main, 0.9),
            ['&:hover']: {
              bgcolor: lighten(theme.palette.primary.main, 0.8),
            },
          }}
          fullWidth
        >
          {t('searchTour.plane')}
        </Button>
      </Grid2>
    </Grid2>
  );
}
